import { AxiosRequestConfig, AxiosError, AxiosResponse } from "axios"

export const onRequestConfig = (config: AxiosRequestConfig): void => {
    // const token = localStorage.getItem("token")
    // if (token) config.headers.token = token
}

export const onRequestConfigError = (error: AxiosError): void => {
    console.log(error)
}

export const onNoServerResponse = (error: AxiosError): void => {
    console.log(error)
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const onResponse = (response: AxiosResponse): void => {
    // This is an empty function.
}

export const onResponseError = (error: AxiosError): void => {
    console.log(error)
    switch (error?.response?.status) {
        // case 401:
        //     window.location.href = process.env.CONTEXT_PATH + "/login"
        //     break
    }
}
